module.exports = __webpack_public_path__ + "static/media/cheMobile@2x.1962adcd.png";